module.exports = __webpack_public_path__ + "img/5.7db8b712.png";